import { component } from "preact";
import { css } from "emotion";

const Note = ({
  color = "#323232",
  marginTop = 0,
  marginBottom = 0,
  breakpoint = 600,
  marginBottomMobile = 0,
  marginTopMobile = 0,
  semiBold,
  children
}) => {
  const styleObj = {
    fontSize: 12,
    fontWeight: semiBold ? 600 : 400,
    color: color,
    marginTop: marginTop,
    marginBottom: marginBottom
  };

  styleObj[`@media(max-width:${breakpoint}px)`] = {
    fontSize: 12,
    marginTop: marginTopMobile,
    marginBottom: marginBottomMobile
  };

  const style = css(styleObj);

  return <p className={style}>{children}</p>;
};

export default Note;
